export const CreditNoteLabel = {
    CreditNoteOrderTitle: "Credit Note",
    OriginalInvoiceNumber: "Original Invoice Number",
    OriginalInvoiceDate: "Original Invoice Date",
    CreditNoteNumber: "Credit Note No",
    CreditNoteAmount: "Credit Note Amount",
    CreditNoteDate: "Credit Note Date",
    EWayBill: "E Way Bill",
    EWayBillAccessor: "e_way_bill",
    OriginalInvoiceNumberAccessor: 'original_invoice_number',
    OriginalInvoiceDateAccessor: 'original_invoice_date',
    NewCreditNote: "New Credit Note",
    EditCreditNote:"Edit Credit Note",
    CreditNoteNoAccessor: "credit_note_no",
    CreditNoteDateAccessor: "credit_note_date",
    CreditNoteAmountAccessor: "credit_note_amount",
    Reason: "Reason",
}